/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactMarkdown from 'react-markdown';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {
    string, shape, object, bool,
} from 'prop-types';

import { setUserConfirmationForSubscriptionPopup } from '../../../../../state/ducks/App/App-Actions';

const styles = (theme) => ({
    imageMainContainer: {
        display: 'flex',
    },
    popUpHeading: {
        textAlign: 'center',
        '& h2': {
            fontSize: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '18px',
            },
        },
    },
    imageTitle: {
        textAlign: 'center',
        fontSize: '18px',
        [theme.breakpoints.down('md')]: {
            fontSize: '14px',
        },
    },
    imageContainer: {
        width: '33%',
        '& img': {
            width: '100%',
            padding: '0px 30px',
        },
    },
    bottomContent: {
        margin: '0 auto',
        padding: '20px 0',
        fontSize: '20px',
        fontWeight: '600',
        color: theme.palette.black || '#000',
        textTransform: 'uppercase',
        textDecoration: 'underline',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    closeBtn: {
        position: 'absolute',
        top: '0',
        right: '0',
    },

});
const SubscriptionModalPopup = ({
    isShowing, closeModal, termModal, classes, handleUserConfirmation,
}) => {
    if (!termModal) {
        return null;
    }
    const userConfirmation = () => {
        handleUserConfirmation(true);
        closeModal();
    };
    const imageOne = termModal.image_one || '';
    const imageTwo = termModal.image_two || '';
    const imageThree = termModal.image_three || '';
    return (
        <Dialog open={isShowing}>
            <DialogTitle className={classes.popUpHeading}>
                <h2>How Our Subscriptions Work</h2>
                <IconButton className={classes.closeBtn} aria-label="Close" onClick={userConfirmation}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <div className={classes.imageMainContainer}>
                    <div className={classes.imageContainer}>
                        <img src={imageOne.href} alt={imageOne.title} />
                        <p className={classes.imageTitle}>{imageOne.title}</p>
                    </div>
                    <div className={classes.imageContainer}>
                        <img src={imageTwo?.href} alt={imageTwo.title} />
                        <p className={classes.imageTitle}>{imageTwo.title}</p>
                    </div>
                    <div className={classes.imageContainer}>
                        <img src={imageThree?.href} alt={imageThree.title} />
                        <p className={classes.imageTitle}>{imageThree.title}</p>
                    </div>
                </div>
                <Typography>
                    <ReactMarkdown classes={classes.termCopy} source={termModal?.multi_line_terms} escapeHtml={false} />
                </Typography>
            </DialogContent>
            <DialogActions>
                <IconButton aria-label="close" className={classes.bottomContent} onClick={userConfirmation}>
                    <span>I Understand</span>
                </IconButton>
            </DialogActions>
        </Dialog>
    );
};

SubscriptionModalPopup.propTypes = {
    classes: object.isRequired,
    isShowing: string.isRequired,
    closeModal: string.isRequired,
    termModal: shape({
        title: string,
        href: string,
    }).isRequired,
    handleUserConfirmation: bool.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    handleUserConfirmation: bindActionCreators(setUserConfirmationForSubscriptionPopup, dispatch),
});

const styledSubscriptionModalPopup = withStyles(styles)(SubscriptionModalPopup);
export default connect(null, mapDispatchToProps)(styledSubscriptionModalPopup);
